/**
 * Shared constants across all platforms (Native, Web, etc.)
 */

/**
 * The identifier used for local data created when in Visitor Mode (unauthenticated).
 */
export const VISITOR_ID = "visitor";

/**
 * Standard HTTP Status Codes
 */
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;

/**
 * The slug for the default "Inbox" list.
 */
export const INBOX_SLUG = "inbox";

/**
 * A stable reference for an empty array to prevent unnecessary re-renders in hooks.
 */
export const EMPTY_ARRAY: readonly never[] = Object.freeze([]);

/**
 * Deep Linking Configuration
 */
export const APP_SCHEME = "stockpilot";
export const APP_DOMAIN = "app.example.com";

/**
 * SOFT_DELETE_STANDARD — trash retention (days) before server-side
 * physical purge (hourly job, see `core-rust/src/db/trash.rs`). Also
 * used on the client for the countdown "will be permanently deleted in N
 * days" in the trash view. Must match the server default
 * (`TRASH_PURGE_DAYS`, env var; 0 = purge disabled).
 */
export const TRASH_PURGE_DAYS = 30;
